import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type PartnerService from 'tio-employee/services/partner';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store as StoreService } from '@warp-drive/core';

export default class AuthenticatedContactUsRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;
  @service declare partner: PartnerService;

  async model() {
    return this.partner.companySettings;
  }
}
